import axios from "axios";
import { PROP_API_KEY, PROP_AUTH_KEY } from '../../constants.js';
const APIURL = "https://api.touchyo.me/";

export const sendAPIRequest = async (path, postData) => {
 console.log(`Request ${path} to ${postData}`);

 try {
  const url = APIURL + path;
  const response = await axios.post(url, postData, { withCredentials: true });

  // レスポンスの形式をバックエンドの実装に合わせる
  if (response.status === 200 && response.data) {
   return response.data;
  }
 } catch (error) {
  if (error.response.status === 400 || error.response.status === 401) {
   alert(`エラー: ${error.response.status} - ${error.response.data.message || 'サーバーでエラーが発生しました。'}`);
  }
  return null;
 }
}

/**
 * ProjectIDが利用可能かチェックする
 * @param {string} projectId 
 * @returns {Promise<{isAvailable: boolean}>}
 */
export const getTouchCodenew = async (code, project, func) => {

 const postData = { "ProjectID": project, "code": code };

 try {
  const res_data = await sendAPIRequest("card/info", postData);
  func(res_data);
 } catch (error) {
  console.error("Project fetch API call failed:", error);
  return null;
 }
};

export const processTouchCode = async (code, project, func) => {

 const postData = { "ProjectID": project, "Code": code };

 try {
  const res_data = await sendAPIRequest("card/use", postData);
  func(res_data);
 } catch (error) {
  console.error("Project fetch API call failed:", error);
  return null;
 }
};

export const processTouchCodeURS = async (code, project, user_id, func) => {

 const postData = { "ProjectID": project, "Code": code, "MailAddress": user_id };

 try {
  const res_data = await sendAPIRequest("card/use", postData);
  func(res_data);
 } catch (error) {
  console.error("Project fetch API call failed:", error);
  return null;
 }
};

/*
export function getTouchCode(code, project, func) {
 var url = "https://api.touchyo.me/card/check?code=" + code;
 if (project !== "") {
  url += "&pj=" + project;
 }

 var params = {};

 const url_params = new URLSearchParams(params);
 axios.post(url, url_params).then((response) => {
  func(response.data);
 });
}*/

export function get_download_id(code, project, func) {
 var url = "https://zgigt31qjg.execute-api.ap-northeast-1.amazonaws.com/Product/CreateDownloadToken?code=" + code;

 if (project !== "") {
  url += "&pj=" + project;
 }

 var obj_param = {};

 const url_params = new URLSearchParams(obj_param);
 axios.post(url, url_params).then((response) => {
  func(response.data);
 });
}

export function get_content_info(cid, func) {
 if (cid && cid.length > 0) {
  var url = "https://license.keyring.net/BookEnd/owner/content/info/v3/get";
  var obj_param = {
   APIKey: PROP_API_KEY,
   KeyID: cid,
   Type: 2,
   OwnerID: 1
  };

  const url_params = new URLSearchParams(obj_param);
  axios.post(url, url_params).then((response) => {
   if (response.data.Status === 0) {
    func(response.data.Content);
   } else {
    alert(response.data.Status + ":" + response.data.StatusDescription);
   }
  });
 }
}

export function openContents(cid, dl_id, type, authKey, cInfo) {
 // DownloadIDを指定して開く
 try {
  // eslint-disable-next-line no-undef
  var curl = BEObj.getContentsURL({ cid: cid, type: 1, cdn: true });
  // eslint-disable-next-line no-undef
  var turl = BEObj.getContentsURL({ cid: cid, type: 2, cdn: true });
  // eslint-disable-next-line no-undef
  BEObj.downloadContents({
   AuthKey: authKey,
   GlobalDownloadID: dl_id,
   ContentsURL: curl,
   ThumbURL: turl,
   Title: cInfo.Title,
   ContentsType: type,
   DownloadablePlatform: "all",
   NewScheme: true,
   CustomScheme: true
  });
 } catch (e) {
  alert(e.message);
 }
}

export function start_app() {
 alert("start_app");
}

export function rem_tags(string) {
 if (string) {
  string = string.replace(/<[//]*em>/g, '');
  return string;
 }
}

export function isMobile() {
 var ua = navigator.userAgent;
 if (ua.indexOf('iPhone') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)) {
  // スマートフォン用コード
  return true;
 } else if (navigator.userAgent.indexOf('Safari') > 0 && navigator.userAgent.indexOf('Chrome') === -1 && typeof document.ontouchstart !== 'undefined') {
  // タブレット用コード
  return true;
 } else {
  // PC用コード
  return false;
 }
}